import { useLocation } from "react-router-dom";
import { useRecordNavigation } from "@jkast90/kast-common/diagnostics/react";

/**
 * Records each section visited for the bug report. The page to return to after
 * sign-in is saved when sign-in starts (auth/signIn.ts), not here.
 */
export default function RouteTracker() {
  useRecordNavigation(useLocation().pathname);
  return null;
}
